import { EnumType, IEnumType } from "./Base/EnumType";

export class UnitOfMeasure extends EnumType {
    // #region Constants

    public static readonly Placeholder = "PLACEHOLDER";

    // #endregion Constants

    // #region Properties
    // #endregion Properties

    // #region Methods

    public fromDto(dto: IUnitOfMeasure) {
        super.fromDto(dto);
    }

    // #endregion Methods
}

export interface IUnitOfMeasure extends IEnumType {}
